import React, { useState } from "react";
import * as Yup from "yup";
import clsx from "clsx";
import { Link ,useNavigate} from "react-router-dom";
import { useFormik } from "formik";
import { requestPassword } from "../redux/AuthCRUD";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toAbsoluteUrl } from "../../../../_jutemplate/helpers/AssetHelpers";

const initialValues = {
  phone: "",
};

const forgotPasswordSchema = Yup.object().shape({
  phone: Yup.string().required("Phone number  is required"),
});

export function ForgotPassword() {

  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      setLoading(true);
      setTimeout(() => {
        requestPassword(values.phone).then(
          (res: any) => {
            setLoading(false);
            if (res?.data?.success === true) {
              formik.resetForm();
              navigate('/auth/otp',{ state: {otp:res?.data?.otp, phone:res?.data?.phone} })
              toast.success(res?.data?.message, {
                position: "top-right",
                theme: "colored",
              });
            } else {
              toast(res?.data?.message, {
                 theme: "dark",
              });
            }
          },
          (err: any) => {
            setLoading(false);
            if (err?.response?.data?.success === false) {
              toast(err?.response?.data?.message, {
                theme: "dark",
              });
            }
            console.log(err);
          }
        );
      }, 100);
    },
  });

  return (
    <>
      <>
        {/* alert */}
        {/* <ToastContainer /> */}

        {/* form */}
        <form
          className="form w-100"
          onSubmit={formik.handleSubmit}
          noValidate
          id="kt_login_signin_form"
        >
          {/* begin :: Heading */}
          <div className="d-flex flex-column align-items-center ">
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/logo-hanay.svg")}
              // className="h-45px"
              style={{ height: "180px" }}
            />
            <h2
              className="fw-semibold m-0 mb-2"
              style={{ color: "#2F3367", fontSize: "18px" }}
            >
              Get Code
            </h2>
            <h5
              className="fw-normal m-0"
              style={{ color: "#303468", fontSize: "18px" }}
            >
              Please! Provide Your Phone Number
            </h5>
          </div>

          {/* begin::Heading */}

          {/* begin::Form group */}
          <div className="fv-row mt-10">
            {/* <label className="form-label fs-6 fw-bolder text-dark">Phone Number</label> */}
            <input
              placeholder="Your Phone Number"
              {...formik.getFieldProps("phone")}
              className={clsx(
                "form-control form-control-lg form-control-solid rounded-2",
                { "is-invalid": formik.touched.phone && formik.errors.phone },
                {
                  "is-valid": formik.touched.phone && !formik.errors.phone,
                }
              )}
              type="text"
              name="phone"
              autoComplete="off"
            />
            {formik.touched.phone && formik.errors.phone && (
              <div className="fv-plugins-message-container">
                <span role="alert" className="error text-danger">
                  {formik.errors.phone}
                </span>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Action */}

          <button
            type="submit"
            id="kt_sign_in_submit"
            className="loginbtn w-100 mt-10"
            // disabled={formik.isSubmitting || !formik.isValid}
            disabled={loading ? true : false}
          >
            {!loading && <span className="indicator-label">Submit</span>}
            {loading && (
              <span className="indicator-progress" style={{ display: "block" }}>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>

          <div className="d-flex justify-content-end mt-5">
            <Link to="/login" className="ps-3 forgotpassword-link">
              Back to Login
            </Link>
          </div>
          {/* end::Action */}
        </form>
      </>
    </>
  );
}
